export default __webpack_public_path__ + "static/media/kitchen5-afterA-1920w.5cb60cb3.avif";